import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PreviewPublishContent from './PreviewPublishContent';

const PreviewProjectModal = ({
  projectId,
  projectDetail,
  versions,
  selVersion,
  popoverOpen,
  toggle,
  isPreviewPublishing,
  handleVersionChange,
  publishApp,
  actions,
  version,
  isReadOnly,
}) => {
  return (
    <Modal size="lg" isOpen={popoverOpen} toggle={toggle} backdrop="static" className="publish">
      <ModalHeader toggle={toggle} className="border-bottom">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '48rem' }}
        >
          <strong>Publish your app for the preview.</strong>
        </div>
      </ModalHeader>
      <ModalBody>
        <PreviewPublishContent
          variant="table"
          projectId={projectId}
          projectDetail={projectDetail}
          versions={versions}
          selVersion={selVersion}
          isPreviewPublishing={isPreviewPublishing}
          handleVersionChange={handleVersionChange}
          publishApp={publishApp}
          actions={actions}
          version={version}
        />
      </ModalBody>
    </Modal>
  );
};

export default PreviewProjectModal;
